import type {StateProvider} from '@uirouter/angularjs';
import {KpSvelteComponentWrapperComponent} from 'core/kp-svelte-component-wrapper/kp-svelte-component-wrapper.component';

/*@ngInject*/
export function sutorReportsApprovingRoutes($stateProvider: StateProvider) {
    let reportsProcessingModule: {default: any;};

    if (window.portaroConfiguration.isSutorSutinLayout) {
        $stateProvider
            .state({
                name: 'reports-approving',
                url: '/reports/approving',
                component: KpSvelteComponentWrapperComponent.componentName,
                resolve: {
                    component: () => reportsProcessingModule.default
                },
                lazyLoad: async () => {
                    reportsProcessingModule = await import(/* webpackChunkName: "reportsApproving" */ '../SutorReportsApprovingPage.svelte');
                    return null;
                }
            });
    }
}